/**
 * Api Documentation
 * Api Documentation
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs/Observable';

import { ProductDTO } from '../model/productDTO';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class ProductControllerService {

    protected basePath = 'https://localhost:8084';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (let consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Retrieve the Products corresponding to the given type and market hub between delivery dates
     * Retrieve the Products corresponding to the given type and market hub between delivery dates
     * @param productTypeId productTypeId
     * @param marketHubId marketHubId
     * @param startDate startDate
     * @param endDate endDate
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public findAvailableProductsByTypeAndMarketHubBetweenDeliveryDatesUsingGET(productTypeId: string, marketHubId: string, startDate: string, endDate: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ProductDTO>>;
    public findAvailableProductsByTypeAndMarketHubBetweenDeliveryDatesUsingGET(productTypeId: string, marketHubId: string, startDate: string, endDate: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ProductDTO>>>;
    public findAvailableProductsByTypeAndMarketHubBetweenDeliveryDatesUsingGET(productTypeId: string, marketHubId: string, startDate: string, endDate: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ProductDTO>>>;
    public findAvailableProductsByTypeAndMarketHubBetweenDeliveryDatesUsingGET(productTypeId: string, marketHubId: string, startDate: string, endDate: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (productTypeId === null || productTypeId === undefined) {
            throw new Error('Required parameter productTypeId was null or undefined when calling findAvailableProductsByTypeAndMarketHubBetweenDeliveryDatesUsingGET.');
        }
        if (marketHubId === null || marketHubId === undefined) {
            throw new Error('Required parameter marketHubId was null or undefined when calling findAvailableProductsByTypeAndMarketHubBetweenDeliveryDatesUsingGET.');
        }
        if (startDate === null || startDate === undefined) {
            throw new Error('Required parameter startDate was null or undefined when calling findAvailableProductsByTypeAndMarketHubBetweenDeliveryDatesUsingGET.');
        }
        if (endDate === null || endDate === undefined) {
            throw new Error('Required parameter endDate was null or undefined when calling findAvailableProductsByTypeAndMarketHubBetweenDeliveryDatesUsingGET.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<Array<ProductDTO>>(`${this.basePath}/api/products/by-type/${encodeURIComponent(String(productTypeId))}/by-market-hub/${encodeURIComponent(String(marketHubId))}/between-delivery-dates/${encodeURIComponent(String(startDate))}/${encodeURIComponent(String(endDate))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Retrieve the Products corresponding to the given type and market hub between observation dates
     * Retrieve the Products corresponding to the given type and market hub between observation dates
     * @param productTypeId productTypeId
     * @param marketHubId marketHubId
     * @param startDate startDate
     * @param endDate endDate
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public findAvailableProductsByTypeAndMarketHubBetweenObservationDatesUsingGET(productTypeId: string, marketHubId: string, startDate: string, endDate: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ProductDTO>>;
    public findAvailableProductsByTypeAndMarketHubBetweenObservationDatesUsingGET(productTypeId: string, marketHubId: string, startDate: string, endDate: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ProductDTO>>>;
    public findAvailableProductsByTypeAndMarketHubBetweenObservationDatesUsingGET(productTypeId: string, marketHubId: string, startDate: string, endDate: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ProductDTO>>>;
    public findAvailableProductsByTypeAndMarketHubBetweenObservationDatesUsingGET(productTypeId: string, marketHubId: string, startDate: string, endDate: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (productTypeId === null || productTypeId === undefined) {
            throw new Error('Required parameter productTypeId was null or undefined when calling findAvailableProductsByTypeAndMarketHubBetweenObservationDatesUsingGET.');
        }
        if (marketHubId === null || marketHubId === undefined) {
            throw new Error('Required parameter marketHubId was null or undefined when calling findAvailableProductsByTypeAndMarketHubBetweenObservationDatesUsingGET.');
        }
        if (startDate === null || startDate === undefined) {
            throw new Error('Required parameter startDate was null or undefined when calling findAvailableProductsByTypeAndMarketHubBetweenObservationDatesUsingGET.');
        }
        if (endDate === null || endDate === undefined) {
            throw new Error('Required parameter endDate was null or undefined when calling findAvailableProductsByTypeAndMarketHubBetweenObservationDatesUsingGET.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<Array<ProductDTO>>(`${this.basePath}/api/products/by-type/${encodeURIComponent(String(productTypeId))}/by-market-hub/${encodeURIComponent(String(marketHubId))}/between-observation-dates/${encodeURIComponent(String(startDate))}/${encodeURIComponent(String(endDate))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Retrieve the given number of Products corresponding to the given type and market hub between observation dates and between delivery dates
     * Retrieve the given number of Products corresponding to the given type and market hub between observation dates and between delivery dates
     * @param productTypeId productTypeId
     * @param marketHubId marketHubId
     * @param startObsDate startObsDate
     * @param endObsDate endObsDate
     * @param startDeliveryDate startDeliveryDate
     * @param endDeliveryDate endDeliveryDate
     * @param numberOfProducts numberOfProducts
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public findAvailableProductsByTypeAndMarketHubForObservationDatesAndBetweenDeliveryDatesUsingGET(productTypeId: string, marketHubId: string, startObsDate: string, endObsDate: string, startDeliveryDate: string, endDeliveryDate: string, numberOfProducts: number, observe?: 'body', reportProgress?: boolean): Observable<Array<Array<ProductDTO>>>;
    public findAvailableProductsByTypeAndMarketHubForObservationDatesAndBetweenDeliveryDatesUsingGET(productTypeId: string, marketHubId: string, startObsDate: string, endObsDate: string, startDeliveryDate: string, endDeliveryDate: string, numberOfProducts: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<Array<ProductDTO>>>>;
    public findAvailableProductsByTypeAndMarketHubForObservationDatesAndBetweenDeliveryDatesUsingGET(productTypeId: string, marketHubId: string, startObsDate: string, endObsDate: string, startDeliveryDate: string, endDeliveryDate: string, numberOfProducts: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<Array<ProductDTO>>>>;
    public findAvailableProductsByTypeAndMarketHubForObservationDatesAndBetweenDeliveryDatesUsingGET(productTypeId: string, marketHubId: string, startObsDate: string, endObsDate: string, startDeliveryDate: string, endDeliveryDate: string, numberOfProducts: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (productTypeId === null || productTypeId === undefined) {
            throw new Error('Required parameter productTypeId was null or undefined when calling findAvailableProductsByTypeAndMarketHubForObservationDatesAndBetweenDeliveryDatesUsingGET.');
        }
        if (marketHubId === null || marketHubId === undefined) {
            throw new Error('Required parameter marketHubId was null or undefined when calling findAvailableProductsByTypeAndMarketHubForObservationDatesAndBetweenDeliveryDatesUsingGET.');
        }
        if (startObsDate === null || startObsDate === undefined) {
            throw new Error('Required parameter startObsDate was null or undefined when calling findAvailableProductsByTypeAndMarketHubForObservationDatesAndBetweenDeliveryDatesUsingGET.');
        }
        if (endObsDate === null || endObsDate === undefined) {
            throw new Error('Required parameter endObsDate was null or undefined when calling findAvailableProductsByTypeAndMarketHubForObservationDatesAndBetweenDeliveryDatesUsingGET.');
        }
        if (startDeliveryDate === null || startDeliveryDate === undefined) {
            throw new Error('Required parameter startDeliveryDate was null or undefined when calling findAvailableProductsByTypeAndMarketHubForObservationDatesAndBetweenDeliveryDatesUsingGET.');
        }
        if (endDeliveryDate === null || endDeliveryDate === undefined) {
            throw new Error('Required parameter endDeliveryDate was null or undefined when calling findAvailableProductsByTypeAndMarketHubForObservationDatesAndBetweenDeliveryDatesUsingGET.');
        }
        if (numberOfProducts === null || numberOfProducts === undefined) {
            throw new Error('Required parameter numberOfProducts was null or undefined when calling findAvailableProductsByTypeAndMarketHubForObservationDatesAndBetweenDeliveryDatesUsingGET.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<Array<Array<ProductDTO>>>(`${this.basePath}/api/products/by-type/${encodeURIComponent(String(productTypeId))}/by-market-hub/${encodeURIComponent(String(marketHubId))}/for-observation-dates/${encodeURIComponent(String(startObsDate))}/${encodeURIComponent(String(endObsDate))}/between-delivery-dates/${encodeURIComponent(String(startDeliveryDate))}/${encodeURIComponent(String(endDeliveryDate))}/number-of-products/${encodeURIComponent(String(numberOfProducts))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Retrieve the given number of Products corresponding to the given type between dates
     * Retrieve the given number of Products corresponding to the given type between dates
     * @param productTypeName productTypeName
     * @param startDate startDate
     * @param endDate endDate
     * @param numberOfProducts numberOfProducts
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public findAvailableProductsByTypeBetweenDatesForNumberOfProductsUsingGET(productTypeName: string, startDate: string, endDate: string, numberOfProducts: number, observe?: 'body', reportProgress?: boolean): Observable<Array<Array<ProductDTO>>>;
    public findAvailableProductsByTypeBetweenDatesForNumberOfProductsUsingGET(productTypeName: string, startDate: string, endDate: string, numberOfProducts: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<Array<ProductDTO>>>>;
    public findAvailableProductsByTypeBetweenDatesForNumberOfProductsUsingGET(productTypeName: string, startDate: string, endDate: string, numberOfProducts: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<Array<ProductDTO>>>>;
    public findAvailableProductsByTypeBetweenDatesForNumberOfProductsUsingGET(productTypeName: string, startDate: string, endDate: string, numberOfProducts: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (productTypeName === null || productTypeName === undefined) {
            throw new Error('Required parameter productTypeName was null or undefined when calling findAvailableProductsByTypeBetweenDatesForNumberOfProductsUsingGET.');
        }
        if (startDate === null || startDate === undefined) {
            throw new Error('Required parameter startDate was null or undefined when calling findAvailableProductsByTypeBetweenDatesForNumberOfProductsUsingGET.');
        }
        if (endDate === null || endDate === undefined) {
            throw new Error('Required parameter endDate was null or undefined when calling findAvailableProductsByTypeBetweenDatesForNumberOfProductsUsingGET.');
        }
        if (numberOfProducts === null || numberOfProducts === undefined) {
            throw new Error('Required parameter numberOfProducts was null or undefined when calling findAvailableProductsByTypeBetweenDatesForNumberOfProductsUsingGET.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<Array<Array<ProductDTO>>>(`${this.basePath}/api/products/by-type/${encodeURIComponent(String(productTypeName))}/between-observation-dates/${encodeURIComponent(String(startDate))}/${encodeURIComponent(String(endDate))}/${encodeURIComponent(String(numberOfProducts))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Retrieve the Products corresponding to the given ids
     * Retrieve the Products corresponding to the given ids
     * @param id id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public findProductsByIdsUsingGET(id: Array<string>, observe?: 'body', reportProgress?: boolean): Observable<Array<ProductDTO>>;
    public findProductsByIdsUsingGET(id: Array<string>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ProductDTO>>>;
    public findProductsByIdsUsingGET(id: Array<string>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ProductDTO>>>;
    public findProductsByIdsUsingGET(id: Array<string>, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling findProductsByIdsUsingGET.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (id) {
            id.forEach((element) => {
                queryParameters = queryParameters.append('id', <any>element);
            })
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<Array<ProductDTO>>(`${this.basePath}/api/products/by-ids`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Retrieve the Products corresponding to the given market hub
     * Retrieve the Products corresponding to the given market hub
     * @param marketHubId marketHubId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public findProductsByMarketHubUsingGET(marketHubId: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ProductDTO>>;
    public findProductsByMarketHubUsingGET(marketHubId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ProductDTO>>>;
    public findProductsByMarketHubUsingGET(marketHubId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ProductDTO>>>;
    public findProductsByMarketHubUsingGET(marketHubId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (marketHubId === null || marketHubId === undefined) {
            throw new Error('Required parameter marketHubId was null or undefined when calling findProductsByMarketHubUsingGET.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<Array<ProductDTO>>(`${this.basePath}/api/products/by-market-hub/${encodeURIComponent(String(marketHubId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Retrieve the Products corresponding to the given period type
     * Retrieve the Products corresponding to the given period type
     * @param periodTypeId periodTypeId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public findProductsByPeriodTypeUsingGET(periodTypeId: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ProductDTO>>;
    public findProductsByPeriodTypeUsingGET(periodTypeId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ProductDTO>>>;
    public findProductsByPeriodTypeUsingGET(periodTypeId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ProductDTO>>>;
    public findProductsByPeriodTypeUsingGET(periodTypeId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (periodTypeId === null || periodTypeId === undefined) {
            throw new Error('Required parameter periodTypeId was null or undefined when calling findProductsByPeriodTypeUsingGET.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<Array<ProductDTO>>(`${this.basePath}/api/products/by-period-type/${encodeURIComponent(String(periodTypeId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Retrieve the Products corresponding to the given product type
     * Retrieve the Products corresponding to the given type
     * @param productTypeId productTypeId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public findProductsByProductTypeUsingGET(productTypeId: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ProductDTO>>;
    public findProductsByProductTypeUsingGET(productTypeId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ProductDTO>>>;
    public findProductsByProductTypeUsingGET(productTypeId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ProductDTO>>>;
    public findProductsByProductTypeUsingGET(productTypeId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (productTypeId === null || productTypeId === undefined) {
            throw new Error('Required parameter productTypeId was null or undefined when calling findProductsByProductTypeUsingGET.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<Array<ProductDTO>>(`${this.basePath}/api/products/by-type/${encodeURIComponent(String(productTypeId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Retrieve the Product corresponding to the given id
     * Retrieve the Product corresponding to the given id
     * @param id id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getProductUsingGET(id: string, observe?: 'body', reportProgress?: boolean): Observable<ProductDTO>;
    public getProductUsingGET(id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ProductDTO>>;
    public getProductUsingGET(id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ProductDTO>>;
    public getProductUsingGET(id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getProductUsingGET.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<ProductDTO>(`${this.basePath}/api/products/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
